import type { WithCommonNextPage } from '../../../utils/page/withProfileUserProps';

import UserProfilePage, { getServerSideProps as UserProfilePageGetServerSideProps } from './index';

const UserProfileSlugPage: WithCommonNextPage = UserProfilePage;

export const getServerSideProps = UserProfilePageGetServerSideProps;

export default UserProfileSlugPage;
